import { useState, useEffect, memo } from 'react';
import { I18n } from 'aws-amplify';
import { cloneDeep } from 'lodash';
import { Box, Typography } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import { elStyle } from '../common/ContractTableHandlerCss';
import '../NormalViewContractDetail.css';
import DropdownSelect from '../common/DropdownSelect';
import { CONTRACT_STATUS, PAYMENT_CYCLE_LIST } from '@/common/constant/NormalContractManagementConstant';

function Plan({
    contractDetail,
    productList,
    setProductList,
    editionList,
    setEditionList,

    product,
    setProduct,
    edition,
    setEdition,
    setVersion,
    paymentCycle,
    setPaymentCycle,
    setBasicSetting,
    setAdvanceSetting,
    setIsUpdateConfirm,

    setIsLoading,
    API,
    currentPaymentCycle
}) {

    const getTextCurrentPaymentCycle = () => {
        let text = '';
        let paymentCycles = PAYMENT_CYCLE_LIST.find(item => item.code === currentPaymentCycle);
        if(!Utils.isEmptyObject(paymentCycles)) {
            text = paymentCycles.name;
        }
        return text;
    }

    return (
        <Typography component="div" className="product-infomation">
            <Box
                component="p"
                className="contract-confirm-label"
                {...elStyle.contract_confirm_label}
            >
                {I18n.get('CM-LABEL-PLAN')}
            </Box>

            <DropdownSelect
                isProduct={true}
                selectedItem={product}
                setSelectedItem={setProduct}
                selectList={productList}
                setSelectList={setProductList}
                API={API}
                setIsLoading={setIsLoading}
                setEditionList={setEditionList}
                setSelectedEdition={setEdition}
                setSelectedVersion={setVersion}
                setBasicSetting={setBasicSetting}
                setAdvanceSetting={setAdvanceSetting}
                setIsUpdateConfirm={setIsUpdateConfirm}
                contractDetail={contractDetail}
            />
            <DropdownSelect
                isEdition={true}
                selectedItem={edition}
                setSelectedItem={setEdition}
                selectList={editionList}
                setSelectList={setEditionList}
                API={API}
                setIsLoading={setIsLoading}
                product={product}
                setProduct={setProduct}
                setProductList={setProductList}
                setSelectedVersion={setVersion}
                setBasicSetting={setBasicSetting}
                setAdvanceSetting={setAdvanceSetting}
                setIsUpdateConfirm={setIsUpdateConfirm}
                contractDetail={contractDetail}
            />
            <DropdownSelect
                isPaymentCycle={true}
                selectedItem={paymentCycle}
                setSelectedItem={setPaymentCycle}
                selectList={PAYMENT_CYCLE_LIST}
                setIsUpdateConfirm={setIsUpdateConfirm}
            />
            

            {currentPaymentCycle !== paymentCycle?.code && contractDetail?.contractStatus == CONTRACT_STATUS.ACTIVE && (
                <Box className="warning-icon" {...elStyle.warning_icon}>
                    <img
                        src="/assets/image/icon-listEmpty.svg"
                        alt="icon-warning"
                        style={{ opacity: 0.7, paddingTop: '5px' }}
                    />
                    <Box component="span" className="warning-content" {...elStyle.warning_content}>
                        {`表示されている金額は ${getTextCurrentPaymentCycle()}（設定された請求サイクル）に基づいて計算されます。${paymentCycle?.name} に基づいて計算された金額は次サイクルにることになります適用されることになります`}
                    </Box>
                </Box>
            )}

            {/* <Box className="dropdown-select" {...elStyle.label_discount}>
                <span />
                <Box component="span" {...elStyle.fz14}>
                    <a href="/" target="_blank"> // out scoped
                        {I18n.get('HYPERLINK-VIEW-PLAN')}
                    </a>
                </Box>
            </Box> */}
        </Typography>
    );
}

export default memo(Plan);
